import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {L1L3AuthService} from "../services/l1-l3-auth.service";

@Injectable({
  providedIn: 'root'
})
export class L1AuthGuard  {

  constructor(private l1l3AuthService: L1L3AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log("L1Guard - canActivate()")
      if (this.l1l3AuthService.getL1Token()) {
        return true;
      } else {
        this.l1l3AuthService.goToLogin(state.url);
      }
      return false;
  }

}
